module.exports = __webpack_public_path__ + "img/quest_icon_0045_hero.f35d5d01.png";